
import AppState, { POPUPS } from '@/js/AppState';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import PopupsManager from 'react-sdk/PopupsManager';
import SoundPlayer from 'react-sdk/SoundPlayer';
import classes from './LeaderboardButton.module.css';

const LeaderboardButton = () => {

  return (
    <div className={classes.LeaderboardButton}
    onClick={() => {
      SoundPlayer.playSound("Click")
      PopupsManager.open(POPUPS.LEADERBOARD)
    }}
    onMouseEnter={() => SoundPlayer.playSound("Roll-over")}>


    <svg
    viewBox="0 0 61 78"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    >
      <path
      d="M39.4388 74.9943H19.7721M39.4388 74.9943V41.8592C39.4388 41.2315 39.1895 40.6295 38.7456 40.1856C38.3018 39.7418 37.6998 39.4924 37.0721 39.4924H22.1388C21.5111 39.4924 20.9092 39.7418 20.4653 40.1856C20.0215 40.6295 19.7721 41.2315 19.7721 41.8592V74.9943M39.4388 74.9943H55.7388C56.3665 74.9943 56.9685 74.745 57.4123 74.3011C57.8561 73.8572 58.1055 73.2552 58.1055 72.6275V63.5548C58.1055 62.9271 57.8561 62.3251 57.4123 61.8813C56.9685 61.4374 56.3665 61.188 55.7388 61.188H41.8055C41.1778 61.188 40.5758 61.4374 40.132 61.8813C39.6881 62.3251 39.4388 62.9271 39.4388 63.5548V74.9943ZM19.7721 74.9943V55.6655C19.7721 55.0378 19.5228 54.4358 19.079 53.9919C18.6351 53.5481 18.0331 53.2987 17.4055 53.2987H4.47214C3.84446 53.2987 3.24249 53.5481 2.79865 53.9919C2.35481 54.4358 2.10547 55.0378 2.10547 55.6655V72.6275C2.10547 73.2552 2.35481 73.8572 2.79865 74.3011C3.24249 74.745 3.84446 74.9943 4.47214 74.9943H19.7721Z"
      stroke="currentColor"
      strokeWidth={5}
      strokeLinecap="round"
      strokeLinejoin="round"
      />
      <path
      d="M29.7797 35.2639L23.9442 20.7584L16.1055 17.2419L25.9474 14.2749L29.7797 5.26392L33.3506 14.2749L43.1055 17.2419L35.441 20.7584L29.7797 35.2639Z"
      stroke="currentColor"
      strokeWidth={5}
      />
    </svg>
    </div>
  );
};



export default observer(LeaderboardButton);
